const initialState = {
    matchingRuleNames: [],
    matchingRuleNamesForSelectionBox: [],
    mappedProcessingOrders: [],
    unMappedMatchingRules: [],
    unMappedWorkflowRules: [],
    allWorkFlowRules: []
};

export default initialState;
